import { render } from "./PageClassList.vue?vue&type=template&id=4dde39e6"
import script from "./PageClassList.vue?vue&type=script&lang=js"
export * from "./PageClassList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/shenshenmac/codes/fan_mei/fanmei_v3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__